import "./CardColorBlock.css";

export default function CardColorBlock({ color, title, text, iconClassName, iconStyle, image }) {
  return (
    <div className="card-color-block" style={{ backgroundColor: color }}>
      <div className="card-color-block-image">
        {image ? (
          <img src={image} alt={title + ' image'} style={{ width: "80px"}} />
        ) : (
          iconClassName && <i className={iconClassName} style={iconStyle} />
        )}
      </div>
      <div className="card-color-block-content">
        <h2 className="card-color-block-title">{title}</h2>
        <div className="card-color-block-text">{text}</div>
      </div>
    </div>
  );
};